import { Box } from '@mantine/core';
import { PageBody, PageContent, PagePanel, PanelBody, PaneledPage } from '@root/Design/Layout';
import { endpoint } from '@root/Services/Router/EndpointRegistry';
import { BillingInvoicesGrid } from '@root/Components/BillingInvoices/BillingInvoicesGrid';

export const MyBillingInvoices = () => {
    return (
        <PageBody>
            <PageContent>
                <PaneledPage>
                    <PagePanel size="fill">
                        <PanelBody>
                            <BillingInvoicesGrid isAdminView={true}></BillingInvoicesGrid>
                        </PanelBody>
                    </PagePanel>
                </PaneledPage>
            </PageContent>
        </PageBody>
    );
};
endpoint('billing-invoices', MyBillingInvoices, 'Billing Invoices');
